import { useContextSelectors } from "@-/com.npmjs.use-context-selectors";
import { PrimaryControlsStripBack } from "@-/dev.improve.haniverse.routes.nav._components.primary-controls-strip.back";
import { BrowseLayoutContext } from "#browse-layout-context";

/**
 * The back control for a non-tab-root browse page (the morpheme detail pages).
 * Reads `parentBrowseTab` from `BrowseLayoutContext` and publishes it as the header back label via
 * `PrimaryControlsStripBack`, so the chevron reads "Characters" / "Words" / … — whichever browse
 * surface the user came from — and a press returns there. Tab-root pages (Levels / Characters /
 * Primitives / Words) don't render this: they're the destinations, not detail pages.
 */
export function BrowseNavBackButton() {
  const [parentBrowseTab] = useContextSelectors(BrowseLayoutContext, (c) => c.parentBrowseTab);
  return (
    <PrimaryControlsStripBack appShellPlacement="toolbar" fallbackHref="/(nav)/(app)/browse">
      {parentBrowseTab}
    </PrimaryControlsStripBack>
  );
}
